import AlertCircleIcon from "../../icons/AlertCircleIcon";
import ClockIcon from "../../icons/ClockIcon";
import styles from "./messageBubble.module.css";

// A small icon button for a bubble's hover actions (edit, delete…).
export const BubbleAction = ({ label, onClick, children }) => (
  <button
    type="button"
    className={styles.actionButton}
    aria-label={label}
    title={label}
    onClick={onClick}
  >
    {children}
  </button>
);

// One message, shared by the support chats and the tickets. Everything shown
// is resolved by the caller.
//   side: "player" (on the reading side) or "support" (across from them)
//   groupStart / groupEnd: its place in a run of messages from that side
//   senderLabel: who on the team wrote it, above the first bubble of a run
//   time / timeTitle / dateTime: the clock time, the full moment, ISO
//   delivery: "sending" | "failed" for a message sent from here; a failed
//     one offers onRetry / onDiscard
//   attachments: shown above the text; actions: shown beside it on hover
const MessageBubble = ({
  side,
  groupStart,
  groupEnd,
  senderLabel = "",
  text = "",
  deleted = false,
  edited = false,
  time,
  timeTitle,
  dateTime,
  delivery,
  onRetry,
  onDiscard,
  attachments = null,
  actions = null,
}) => {
  const fromSupport = side === "support";

  const rowClass = [
    styles.row,
    fromSupport ? styles.support : styles.player,
    groupStart && styles.groupStart,
    groupEnd && styles.groupEnd,
  ]
    .filter(Boolean)
    .join(" ");

  const bubbleClass = [
    styles.bubble,
    deleted && styles.deleted,
    delivery === "sending" && styles.sending,
    delivery === "failed" && styles.failed,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={rowClass}>
      <div className={styles.stack}>
        {senderLabel && groupStart && (
          <span className={styles.sender} dir="auto">
            {senderLabel}
          </span>
        )}
        <div className={bubbleClass}>
          {deleted ? (
            <span className={styles.deletedText}>تم حذف هذه الرسالة</span>
          ) : (
            <>
              {attachments}
              {text && (
                <div className={styles.text} dir="auto">
                  {text}
                </div>
              )}
            </>
          )}
          <div className={styles.meta}>
            {!deleted && edited && <span>مُعدّلة</span>}
            <time dateTime={dateTime} title={timeTitle}>
              {time}
            </time>
            {delivery === "sending" && (
              <span className={styles.metaIcon} title="جارٍ الإرسال">
                <ClockIcon />
              </span>
            )}
            {delivery === "failed" && (
              <span className={`${styles.metaIcon} ${styles.metaIconFailed}`} title="لم تُرسل">
                <AlertCircleIcon />
              </span>
            )}
          </div>
        </div>

        {delivery === "failed" && (
          <div className={styles.failedRow} role="alert">
            <span>لم تُرسل</span>
            {onRetry && (
              <button type="button" className={styles.failedAction} onClick={onRetry}>
                إعادة المحاولة
              </button>
            )}
            {onDiscard && (
              <button type="button" className={styles.failedAction} onClick={onDiscard}>
                تجاهل
              </button>
            )}
          </div>
        )}
      </div>

      {actions && <div className={styles.actions}>{actions}</div>}
    </div>
  );
};

export default MessageBubble;
